import { ReactNode, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useMediaQuery } from "../../../hooks/common";

export type MenuProps = {
  className?: string;
  anchor?: Element | null;
  children?: ReactNode | ReactNode[];
  onClose: () => void;
  open: boolean;
};

export function Menu({
  open,
  onClose,
  children,
  className,
  anchor,
}: MenuProps) {
  const element = useRef<Element>();
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    if (!anchor) return () => null;
    if (open && !document.body.classList.contains("overflow-hidden")) {
      document.body.classList.add("overflow-hidden");
      return () => document.body.classList.remove("overflow-hidden");
    }

    return () => null;
  }, [open, anchor]);

  if (!open || !anchor) return null;

  const { left, bottom, top, width, height } = anchor.getBoundingClientRect();

  return createPortal(
    <div
      className="fixed inset-0 bg-transparent z-[1300] overflow-hidden"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="fixed bg-white z-[1301] border border-gray-400 rounded-lg"
        style={{
          ...(isMobile
            ? { bottom: window.innerHeight - top + 8 }
            : { top: bottom + 8 }),
          left,
          width,
        }}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}

export function FreeSizeMenu({
  open,
  onClose,
  children,
  className,
  anchor,
}: MenuProps) {
  const element = useRef<Element>();

  useEffect(() => {
    if (!anchor) return () => null;
    if (open && !document.body.classList.contains("overflow-hidden")) {
      document.body.classList.add("overflow-hidden");
      return () => document.body.classList.remove("overflow-hidden");
    }

    return () => null;
  }, [open, anchor]);

  if (!open || !anchor) return null;

  const { right, bottom } = anchor.getBoundingClientRect();

  return createPortal(
    <div
      className="fixed inset-0 bg-transparent z-[1300] overflow-hidden"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="fixed bg-white z-[1301] border border-gray-400 rounded-lg"
        style={{
          top: bottom + 8,
          right: window.innerWidth - right,
        }}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
